var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLikertIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 28,
    viewBox: "0 0 23 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.3979 0H0.943158C0.412632 0 0 0.412632 0 0.943158V27.0568C0 27.5874 0.412632 28 0.943158 28H21.3979C21.9284 28 22.3411 27.5874 22.3411 27.0568V0.943158C22.3411 0.412632 21.9284 0 21.3979 0ZM20.4547 26.1137H1.88632V1.88632H20.4547V26.1137Z",
    fill: "#A9A7A7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M5.71757 18.6864H16.6523C17.1828 18.6864 17.5955 18.2737 17.5955 17.7432C17.5955 17.2127 17.1828 16.8 16.6523 16.8H5.71757C5.18705 16.8 4.77441 17.2127 4.77441 17.7432C4.77441 18.2737 5.18705 18.6864 5.71757 18.6864Z",
    fill: "#A9A7A7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M5.71799 22.901H16.6527C17.1833 22.901 17.5959 22.4883 17.5959 21.9578C17.5959 21.4273 17.1833 21.0146 16.6527 21.0146H5.71799C5.18746 21.0146 4.77483 21.4273 4.77483 21.9578C4.74536 22.4883 5.18746 22.901 5.71799 22.901Z",
    fill: "#A9A7A7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M8.69441 8.1937H9.54915C9.84389 8.1937 10.0502 7.95791 10.0502 7.69265V7.6337C10.0502 7.54528 10.0797 6.77896 11.2291 6.77896C11.8776 6.77896 12.2902 6.92633 12.2902 7.69265C12.2902 8.13475 11.6123 8.69475 11.2586 8.98949C10.6397 9.49054 10.1386 9.99159 10.1386 11.0232V11.2C10.1386 11.4948 10.3744 11.7011 10.6397 11.7011H11.4944C11.7891 11.7011 11.9955 11.4653 11.9955 11.2V11.0232C11.9955 10.8169 11.9955 10.7874 12.4376 10.4337C13.027 9.93265 14.147 9.01896 14.147 7.69265C14.147 6.36633 13.3807 4.92212 11.2291 4.92212C9.01862 4.92212 8.19336 6.60212 8.19336 7.66317V7.72212C8.19336 7.98738 8.39967 8.1937 8.69441 8.1937Z",
    fill: "#A9A7A7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M11.5834 12.5852H10.5518C10.2571 12.5852 10.0508 12.821 10.0508 13.0863V13.9705C10.0508 14.2652 10.2866 14.4715 10.5518 14.4715H11.5834C11.8781 14.4715 12.0845 14.2357 12.0845 13.9705V13.0863C12.1139 12.821 11.8781 12.5852 11.5834 12.5852Z",
    fill: "#A9A7A7"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikertIcon);
export default __webpack_public_path__ + "static/media/LikertIcon.074abdd38804ddfb4d5fbf3fe5545b3d.svg";
export { ForwardRef as ReactComponent };